import { IUpdateFornecedorUseCase } from "../../../presentation/useCases/update/update_fornecedor_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * UpdateFornecedorUseCase
 */

export class UpdateFornecedorUseCase implements IUpdateFornecedorUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async updateFornecedor(
    idFornecedor: number,
    idCentroCusto: number | null,
    dataCadastro: Date | null,
    razaoSocial: string,
    nomeFantasia: string,
    cnpj: string,
    cpf: string,
    inscricaoEstadual: string,
    inscricaoMunicipal: string,
    atividade: string,
    obsFornecedor: string,
    contato: string,
    telefoneFixo: string,
    telefoneCelular: string,
    email: string,
    contato1: string,
    email1: string,
    descQualificacoes: string,
    fornProduto: boolean,
    fornServico: boolean,
    familia: string,
    ativo: boolean,
    avaliar: boolean,
    avaliacaoFinanceira: string,
    dataValidade: Date | null,
    rua: string,
    numero: string,
    apartamento: string,
    cep: string,
    uf: string,
    cidade: string,
    bairro: string,
    pais: string,
    qualificacoes: {
      idQualificacao: number;
      qualificado: boolean;
      observacao: string;
    }[],
  ): Promise<void> {
    await this.repository.updateFornecedor(
      idFornecedor,
      idCentroCusto,
      dataCadastro,
      razaoSocial,
      nomeFantasia,
      cnpj,
      cpf,
      inscricaoEstadual,
      inscricaoMunicipal,
      atividade,
      obsFornecedor,
      contato,
      telefoneFixo,
      telefoneCelular,
      email,
      contato1,
      email1,
      descQualificacoes,
      fornProduto,
      fornServico,
      familia,
      ativo,
      avaliar,
      avaliacaoFinanceira,
      dataValidade,
      rua,
      numero,
      apartamento,
      cep,
      uf,
      cidade,
      bairro,
      pais,
      qualificacoes.filter(x => x.qualificado === true),
    );
  }
}
